import {
    BrowserRouter as Router,
    Switch,
    Route,
    Redirect,
} from "react-router-dom";
import {useUser} from "./Context/UserContext";
import MainLayout from "./Components/layout/main-layout/MainLayout";
import ProjectComparer from "./App/ProjectComparer";
import LoginForm from "./App/LoginForm";
import ChangePassword from "./App/ChangePassword";
import EditProfile from "./App/EditProfile";
import Register from "./App/Register";
import RegisterSuccess from "./App/RegisterSuccess";
import RegisterVerification from "./App/RegisterVerification";
import InternalCheck from "./App/InternalCheck";
import ComparisonCheck from "./App/ComparisonCheck";
import {HelpPage} from "./Components/HelpPage";
import {Footer} from "antd/es/layout/layout";
import ReportPage from "./App/ReportPage";
import UserSettings from "./App/UserSettings";
import {useEffect} from "react";
import ApiService from "./Service/ApiService";
import LandingPage from "./App/LandingPage";
import UserDashboard from "./App/UserDashboard";
import EULA from "./App/EULA";
import Privacy from "./App/Privacy";
import AdminDashboard from "./App/AdminDashboard";
import UserProfile from "./App/UserProfile";
import ResetPasswordSend from "./App/ResetPasswordSend";
import ResetPassword from "./App/ResetPassword";
import ResetPasswordSuccess from "./App/ResetPasswordSuccess";
import InfoContentPage from "./App/InfoContentPage";
import HelpContentPage from "./App/HelpContentPage";
import ProjectComparerV2 from "./Components/V2/ProjectComparerV2";
import MessageRun from "./Components/V2/MessageRun";
import MessagePage from "./Components/V2/MessagePage";

function PrivateRoute({children, ...rest})
{
    const {
        isAuth,
        setSettings
    } = useUser();

    const getSettings  = async () => {
        const res = await ApiService.User.UserSettings()
        if(res.success) {
            setSettings({
                settings: JSON.parse(res.data.settings),
                defaultSettings: res.data.defaultSettings,
            })
        }
    }

    useEffect(() => {
        getSettings()
    }, [])

    return (
        <Route {...rest} render={() =>
        {
            return isAuth()
                ? children
                : <Redirect to={'/app/login'} />
        }}/>
    )
}


export default function AppRouter()
{
    const {user} = useUser();

    return (
        <Router>
            <Switch>
                <Route path={'/app/login'} component={LoginForm}/>
                <Route path={'/app/register/success'} component={RegisterSuccess}/>
                <Route path={'/app/register/verification'} component={RegisterVerification}/>
                <Route path={'/app/register'} component={Register}/>
                <Route exact path={'/app/reset-password/send'}  component={ResetPasswordSend}/>
                <Route exact path={'/app/reset-password/success'}  component={ResetPasswordSuccess}/>
                <Route exact path={'/app/reset-password'}  component={ResetPassword}/>
                <Route path={'/app/eula'} component={EULA}/>
                <Route path={'/app/privacy'} component={Privacy}/>
                <PrivateRoute>
                    <div style={{display: 'flex', flexDirection: 'column', alignContent: 'space-between', height: '100%'}}>
                        <MainLayout>
                            <Switch>
                                {(<Route exact path={'/app/load-project'}  component={ProjectComparerV2}/>)}
                                {(<Route exact path={'/app/run'}  component={MessageRun}/>)}
                                {/*{(<Route exact path={'/app/comparison-check'}  component={ComparisonCheck}/>)}*/}
                                {(<Route exact path={'/app/messages'}  component={MessagePage}/>)}
                                {(<Route exact path={'/app/help'}  component={HelpPage}/>)}
                                {(<Route exact path={'/app/user/dashboard'}  component={UserDashboard}/>)}
                                {(<Route exact path={'/app/user/profile'}  component={UserProfile}/>)}

                                {user?.data?.isAdmin && (<Route exact path={'/app/admin/dashboard'}  component={AdminDashboard}/>)}
                                {user?.data?.isAdmin && (<Route exact path={'/app/admin/info-content'}  component={InfoContentPage}/>)}
                                {user?.data?.isAdmin && (<Route exact path={'/app/admin/help-content'}  component={HelpContentPage}/>)}

                                {(<Route exact path={'/app/profile/change-password'}  component={ChangePassword}/>)}
                                {(<Route exact path={'/app/profile/settings'}  component={UserSettings}/>)}
                                {(<Route exact path={'/app/profile/edit'}  component={EditProfile}/>)}

                                {(<Route exact path={'/app'}  component={ProjectComparerV2}/>)}
                                {(<Route exact path={'/'}  component={UserDashboard}/>)}
                            </Switch>
                        </MainLayout>
                    </div>
                </PrivateRoute>
            </Switch>
        </Router>
    )
}

